
<template>
  <!--管家钥匙列表-->
  <div>
    <x-tabula
      ref="table"
      :initReqHandle="false"
      :dataSource="dataSource"
      rowKey="passKeyId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="true"
      @resetSearch="resetSearch"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-button v-hasPermi="['community:propertykey:property']" type="link" @click="toMemberDetail(row)">{{row.mobile}}</a-button>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <p v-hasPermi="['community:propertykey:device']" @click="toDevDetail(row.deviceId)">
          <a-button type="link">{{row.deviceName}}</a-button>
          <br>
          <a-button type="link">{{row.devicePosition}}</a-button>
        </p>
      </template>

      <template slot="opt_f" slot-scope="{row}">
        <span>{{row.expireTime | foreverTime}}</span>
      </template>
    </x-tabula>

    <!-- 管家信息弹窗-->
    <a-modal v-model="visible" title="管家信息" :footer="null" width="800px">
      <a-form>
        <a-form-item
          v-for="(item, index) of accountInfo"
          :key="index"
          :label="item.label"
          v-bind="{labelCol: { span: 4 }, wrapperCol: { span: 9 }}"
        >
          <span class="ant-form-text">{{item.value}}</span>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect, defaultDate } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect, defaultDate],
  name: 'stewardKey',
  data () {
    return {
      visible: false,
      accountInfo: [
        { label: '账号', key: 'userName', value: '' },
        { label: '角色', key: 'roleNames', value: '' },
        { label: '手机号', key: 'mobile', value: '' },
        { label: '真实姓名', key: 'trueName', value: '' }
      ],
      cascadeParam: {},
      searchList: [
        { props: [`${this.$route.name}/communityId`], placeholder: '小区名称', options: [], inputType: 'select', handle: ($event) => this.communityChange(7, $event), fetchOptions: this.getOptions},
        { props: ['deviceSncode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['deviceName'], placeholder: '设备名称', options: [], inputType: 'input' },
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: [`${this.$route.name}/createDate`], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          props: ['areaId'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(5, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        { props: [`${this.$route.name}/buildingId`], placeholder: '楼栋', options: [], inputType: 'select', handle: ($event) => this.buildingChange(8, $event) },
        { props: [`${this.$route.name}/unitId`], placeholder: '单元', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '钥匙状态', options: this.$store.state.isExpireList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '分配钥匙', icon: 'setting', handle: this.toAlloc, permi: ['community:propertykey:add'] },
        { text: '删除', icon: 'colse', disabled: true, permi: ['community:propertykey:remove'] }
      ],
      rowOptList: [
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), key: 'delete', permi: ['community:propertykey:remove'] }
      ],
      columns: [
        { title: '管家', dataIndex: 'mobile', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '位置', dataIndex: 'keyPosition', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'deviceName', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '到期时间', dataIndex: 'expireTime', align: 'left', width: '', scopedSlots: {customRender: 'f'} },
        { title: '添加时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        [`${this.$route.name}/communityId`]: undefined,
        deviceSncode: undefined,
        deviceName: undefined,
        mobile: undefined,
        [`${this.$route.name}/createDate`]: [],
        areaId: [],
        propertyId: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        [`${this.$route.name}/unitId`]: undefined,
        status: undefined
      },
      listApi: {
        url: '/property/passKey/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/property/passKey/',
        // param: { pk_key: 'passKeyId', pk_val: '' },
        title: '管家钥匙',
        key: 'keyPosition'
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    this.handleDefaultDate();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.propertySelect(6);
      this.regionSelect(5);
    },
    /* 进入分配钥匙 */
    toAlloc () {
      this.$router.push({
        name: 'allocation',
        query: { type: 'steward', title: '分配管家钥匙', ...this.breadParam(this) }
      });
    },
    /* 进入设备详情 */
    toDevDetail (id) {
      this.$router.push({
        name: 'smartDoorDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /** 查看会员详情弹窗 */
    toMemberDetail (row) {
      this.$get({
        url: `/property/user/${row.memberId}`
      }).then(({data}) => {
        this.accountInfo.forEach((el) => {
          for (let item in data) {
            if (el.key === item) {
              el.value = Array.isArray(data[item]) ? data[item].join(', ') : data[item];
            }
          }
        });
      });
      this.visible = true;
    },
    resetSearch () {
      this.searchList[7].options = [];
      this.searchList[8].options = [];
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
